import React from 'react'

const NotFoundPage = () => {
    return (
        
        <section className="team">
        <div className="overlayed-text">
            <h1 className="meet">Page Not Found!</h1>
            <hr />
            <h3 className="firm">Sorry, the page you requested is not valid. The requested link does not exist.</h3>
        </div>

        </section>
    )
}

export default NotFoundPage
